<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Sybil Woolmore, the youngest of six siblings, was born in Auckland and raised on a remote sheep and cattle farm on the west coast of the North Island of New Zealand. She has always been a very independent person having been sent off to boarding school at aged 13 and then going flatting straight from school. She had no children but inherited two wonderful step children.</p><br/>
<p style="text-indent: 00em;">She enjoyed art for many years, selling several paintings and it wasn’t until they retired and moved to Paeroa from Auckland seven years ago that she started writing and joined a newly formed writing group. She is inspired by life and people around her.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?77643946